import { jsx } from "react/jsx-runtime";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { validateTidalLicense } from "../../base/index.js";
function CreditCard(props) {
  return /* @__PURE__ */ jsx(
    CreditCardIcon,
    {
      "data-testid": "CreditCard",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "CreditCard",
      "data-tidal-icon-meta": "money,invoices,payments"
    }
  );
}
CreditCard.tidalIconMeta = {
  categories: "money,invoices,payments",
  name: "CreditCard"
};
validateTidalLicense();
export {
  CreditCard
};
//# sourceMappingURL=CreditCard.js.map
